<template>
    <v-container max-width="100%" style="margin-top: 2%">

      <template>
      <v-row justify="center">
        <v-dialog
          v-model="progressoDialog"
          persistent
          max-width="500"
          style="height: 300px; z-index: 90000"
        >
          <v-card>
            <v-card-text>
              <v-row justify="center">
                <h3 style="margin-top: 20px; color: #1565c0">
                  {{ this.mensagemProgressoDialog }}
                </h3>
              </v-row>

              <v-row justify="center">
                <v-progress-circular
                  :size="50"
                  :width="5"
                  color="primary"
                  indeterminate
                  style="margin-top: 10px; margin-bottom: 10px"
                ></v-progress-circular>
              </v-row>
            </v-card-text>
          </v-card>
        </v-dialog>
      </v-row>
    </template>
  
      <v-container class="toolbar__container">
        <v-form ref="form" v-model="formValidado">
          <v-row>
            <v-col cols="12" sm="12" md="5">
              <v-autocomplete
                v-model="idEmpresaSelected"
                :items="empresas"
                item-text="razao_social"
                item-value="id_empresa"
                clearable
                :label="$tc('company.self', 1)"
              ></v-autocomplete>
            </v-col>
            <v-col cols="12" sm="4" md="3">
              <v-datetime-picker
                :label="$t('speedReport.startDate')"
                v-model="dti"
                :time-picker-props="timeProps"
                :text-field-props="textFieldProps"
                :date-picker-props="dtiProps"
                time-format="HH:mm:ss"
                date-format="dd/MM/yyyy"
                :clear-text="$t('datetime.close')"
              >
                <template slot="dateIcon">
                  <v-icon>mdi-calendar</v-icon>
                </template>
                <template slot="timeIcon">
                  <v-icon>mdi-clock</v-icon>
                </template>
              </v-datetime-picker>
          </v-col>
          <v-col cols="12" sm="4" md="3">
            <v-datetime-picker
              :label="$t('speedReport.endDate')"
              v-model="dtf"
              :time-picker-props="timeProps"
              :text-field-props="textFieldProps"
              :date-picker-props="dtfProps"
              time-format="HH:mm:ss"
              date-format="dd/MM/yyyy"
              :clear-text="$t('datetime.close')"
            >
              <template slot="dateIcon">
                <v-icon>mdi-calendar</v-icon>
              </template>
              <template slot="timeIcon">
                <v-icon>mdi-clock</v-icon>
              </template>
            </v-datetime-picker>
          </v-col>
          <v-col cols="12" sm="4" md="1">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  small
                  fab
                  color="primary darken-1"
                  class="white--text"
                  v-bind="attrs"
                  v-on="on"
                  @click="populaRelatorio"
                >
                  <v-icon>mdi-magnify</v-icon>
                </v-btn>
              </template>
              <span>{{ $t('operation.search') }}</span>
            </v-tooltip>
          </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" sm="6" md="4">
              <MultiplaEscolha
                ref="linhasSelect"
                lazy
                get-url="getLinhaslazy"
                :request-data="lazySelectRequestData"
                v-bind:selected-items.sync="idLinhaSelected"
                text="nome_linha"
                value="id_linha"
                :label="$tc('line.self', 1)"
                :max-items="2"
              />
            </v-col>
          <v-col cols="12" sm="6" md="4">
            <MultiplaEscolha
              ref="veiculosSelect"
              lazy
              get-url="getVeiculoslazy"
              :request-data="lazySelectRequestData"
              v-bind:selected-items.sync="idVeiculoSelected"
              text="numero_ordem"
              value="id_veiculo"
              :label="$tc('vehicle.self', 1)"
              :max-items="2"
            />
          </v-col>
          <v-col cols="12" sm="6" md="4">
            <MultiplaEscolha
              lazy
              get-url="getUnidadeslazy"
              :items="semUnidadeOption"
              v-bind:selected-items.sync="unidadesSelecionadas"
              text="descricao_unidade"
              value="id_unidade"
              :label="$t('nav.registration.units')"
              :max-items="2"
            />
          </v-col>
          </v-row>
        </v-form>
      </v-container>
  
  <div ref="pdfdiv">
    <merus-data-table
        ref="entradasTable"
        :headers="headers"
        :items="entradasFiltered"
        @update:displayedItems="displayedItemsForExport = $event"
        sort-by="dt_entrada"
        dense
        class="elevation-7"
        locale="pt"
        :loading="loading"
        :loading-text="$t('system.messages.loading')"
        show-expand
        :single-expand="true"
        item-key="id_entrada_diario"
        style="border-radius: 10px; margin-bottom: 10px; margin-top: 10px"
    

 cod-tabela="RELDIARIOBORDO" @update:headers="headers = $event">
        <template v-slot:expanded-item="{ item }">
          <div style="width: 100%; padding: 5px;">
            <v-simple-table dense>
              <template v-slot:default>
                <thead>
                  <tr>
                    <th>{{ $tc('line.self', 1) }}</th>
                    <th>{{ $tc('vehicle.self', 1) }}</th>
                    <th>{{ $tc('trip.self', 2) }}</th>
                    <th>{{ $t('operation.registeredBy') }}</th>
                    <th>{{ $t('operation.editedBy') }}</th>
                    <th>{{ $t('operation.editedAt') }}</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>{{ item.linhas }}</td>
                    <td>{{ item.veiculos }}</td>
                    <td>{{ item.viagens }}</td>
                    <td>{{ item.usuario_inclusao }}</td>
                    <td>{{ item.usuario_edicao }}</td>
                    <td>{{ item.dt_edicao }}</td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </div>
        </template>

        <template v-slot:toolbar>
            <CadastroToolbar
                :title="$t('tripOperation.logbook')"
                :token="token"
                :items="displayedItemsForExport !== null ? displayedItemsForExport : entradasFiltered"
                csv-title="diariodebordo"
                :csv-headers="headers"
                list-endpoint="getentradaspordata"
                :request-params="csvExportRequestParams"
                :post-filters="csvExportPostFilters"
                :export-total="(displayedItemsForExport !== null ? displayedItemsForExport : entradasFiltered).length"
                id-field="id_entrada_diario"
                :pdf-title="$t('tripOperation.logbook')"
                :pdf-headers="headers"
                pdf-filename="diariodebordo"
                :pdf-subtitle="pdfsubtitle"
                hide-search
            />
        </template>
      </merus-data-table>
    </div>
    </v-container>
  </template>
  
  <script>

import apiController from "@/utils/apiController";
import EventBus from "@/utils/eventBus";
import MerusDataTable from "./Tables/MerusDataTable.vue";
import CadastroToolbar from "./Toolbars/CadastroToolbar.vue";
import DateUtils from "../utils/dateutils";
import translateDbField from "@/utils/translateDbField";
import MultiplaEscolha from './Selects/MultiplaEscolha.vue';
import { eqFilter, inFilter, mergePostFilters, multiSearchToPostFilters } from "@/utils/csvExportPostFilters";

  export default {
    components: {
    MerusDataTable,
    CadastroToolbar,
    MultiplaEscolha
},
    data: () => ({
    headers: [],
      user: null,
      token: null,
      displayedItemsForExport: null,
      progressoDialog: false,
      showConfirmButton: true,

      mensagemProgressoDialog: "",
      formValidado: false,
      loading: false,

      timeProps: {
        useSeconds: true,
      },
      dti: null,
      dtf: null,
      idEmpresaSelected:  null,
      idVeiculoSelected: [],
      idLinhaSelected: [],
      empresas: [],
      unidadesSelecionadas: [],
      resolvedIdLinhas: null,
      resolvedIdVeiculos: null,
      entradas: [],
      entradasFiltered: [],
      config: null,
      /** Incrementado após o mount para registrar a dependência reativa do $refs.entradasTable.multiSearch. */
      csvPostFiltersRefreshTick: 0,
    }),
    computed: {
      headersWithProperties() {
        return this.headers.map(header => ({
          ...header,
          filtrable: true,
          sortable: true
        }));
      },
      pdfsubtitle() {
        return "";
      },
      messageConfirmButton() {
        return this.$t('system.labels.confirm');
      },
      messageDismissButton() {
        return this.$t('system.labels.dismiss');
      },
      textFieldProps() {
        return {
        prependInnerIcon: "mdi-calendar",
        rules: [(v) => !!v || this.$t('contract.messages.selectDate')], // (v) => v > this.dtfimbase || "Data início deve ser menor que data fim !"]
        }
      },
      today() {
        return new Date().toISOString().substring(0,10);
      },
      dtiProps() {
        return {
          max: this.today
        }
      },
      dtfProps() {
        let min = null;
        if (this.dti) {
          if (typeof this.dti === 'string') {
            min = `${this.dti.substring(6,10)}-${this.dti.substring(3,5)}-${this.dti.substring(0,2)}`;
          } else {
            min = this.dti.toISOString().substring(0,10);
          }
        }
        return {
          min: min
        }
      },
      semUnidadeOption() {
        return [
          {
            id_unidade: -1,
            descricao_unidade: 'Sem Unidade',
            cod_unidade: 'SU',
          },
        ];
      },
      lazySelectRequestData() {
        const unidades = (this.unidadesSelecionadas || []).map((id) => Number(id));
        const reais = unidades.filter((id) => Number.isFinite(id) && id > 0);
        const temSemUnidade = unidades.includes(-1);
        if (reais.length === 1 && !temSemUnidade) {
          return { id_unidade: reais[0] };
        }
        if (temSemUnidade && reais.length === 0) {
          return { id_unidade: -1 };
        }
        return {};
      },
      /** Mesmo body enviado a getEntradaspordata; reexecutado pelo worker de export CSV. */
      csvExportRequestParams() {
        if (!this.dti || !this.dtf) return {};
        const idlinhas = this.idLinhaSelected.length > 0
          ? this.idLinhaSelected
          : (this.resolvedIdLinhas && this.resolvedIdLinhas.length > 0 ? this.resolvedIdLinhas : null);
        const idveiculos = this.idVeiculoSelected.length > 0
          ? this.idVeiculoSelected
          : (this.resolvedIdVeiculos && this.resolvedIdVeiculos.length > 0 ? this.resolvedIdVeiculos : null);
        return {
          dti: DateUtils.getDateSQLFormatted(this.dti),
          dtf: DateUtils.getDateSQLFormatted(this.dtf),
          idlinhas,
          idveiculos,
          idviagens: null,
        };
      },
      /** postFilters da toolbar CSV: espelha empresa/perfil, unidades e colunas da tabela (multiSearch). */
      csvExportPostFilters() {
        void this.csvPostFiltersRefreshTick;
        const tableRef = this.$refs.entradasTable;
        const multiSearchFilters = tableRef ? multiSearchToPostFilters(tableRef.multiSearch) : {};
        const perfilFilter = this.idEmpresaSelected
          ? eqFilter('id_empresa', this.idEmpresaSelected)
          : eqFilter('id_cliente', this.user && this.user.id_cliente);
        return mergePostFilters(
          perfilFilter,
          inFilter('id_unidade', this.unidadesSelecionadas.map((id) => Number(id))),
          multiSearchFilters
        );
      },
    },
    watch: {
      '$i18n.locale'() {
        this.initialize();
        if (this.$refs.form) {
          this.$refs.form.resetValidation();
        }
      }
    },
    created() {
      this.user = JSON.parse(sessionStorage.getItem("user"));
      this.token = sessionStorage.getItem("api");
      this.initialize();
    },
    mounted() {
      // Força uma reavaliação de csvExportPostFilters após o mount, para que a
      // dependência reativa em $refs.entradasTable.multiSearch seja registrada.
      this.$nextTick(() => { this.csvPostFiltersRefreshTick++; });
    },
    methods: {

      initialize() {
        this.getConfig();
        this.populaEmpresas();
      },
      getConfig() {
          apiController.request(apiController.endpoints.getallConfig, {
              silent: true,
              onSuccess: (response) => {
                  this.config = response.data[0];
                  [this.dti, this.dtf] = DateUtils.setDefaultDateFilters(this.config.hora_inicial_dia_operacao);
              },
              onError: (e) => {
                  console.log("Response : " + e.message);
                  if (e.message == "Request failed with status code 401") {
                    EventBus.$emit('show-error', { error: e });
                  }
              },
          });
        },
      populaEmpresas() {
        apiController.request(apiController.endpoints.getallEmpresas, {
          silent: true,
          onSuccess: (response) => {
            this.empresas = response.data;
          },
          onError: (e) => {
            console.log(this.$t('system.messages.errorAxios'));
            console.log(e.message);
            if (e.message == "Request failed with status code 401") {
              EventBus.$emit('show-error', { error: e });
            }
          },
        });
      },
      aplicaFiltros(dados) {
        if (!dados || !Array.isArray(dados)) {
          return [];
        }
        let filtrados = dados;
        if (this.idEmpresaSelected) {
          filtrados = filtrados.filter((d) => d.id_empresa == this.idEmpresaSelected);
        } else if (this.user && this.user.id_cliente != null && this.user.id_cliente !== '') {
          filtrados = filtrados.filter((d) => d.id_cliente == this.user.id_cliente);
        }
        if (this.unidadesSelecionadas.length > 0) {
          const selecionadas = this.unidadesSelecionadas.map((id) => Number(id));
          filtrados = filtrados.filter((e) => selecionadas.includes(Number(e.id_unidade)));
        }
        return filtrados;
      },
      filtraItensLazyParaIds(dados) {
        if (!dados || !Array.isArray(dados)) {
          return [];
        }
        let filtrados = dados;
        if (this.idEmpresaSelected) {
          filtrados = filtrados.filter((d) => d.id_empresa == this.idEmpresaSelected);
        } else if (this.user && this.user.id_cliente != null && this.user.id_cliente !== '') {
          filtrados = filtrados.filter((d) => d.id_cliente == this.user.id_cliente);
        }
        if (this.unidadesSelecionadas.length > 0) {
          const selecionadas = this.unidadesSelecionadas.map((id) => Number(id));
          filtrados = filtrados.filter((d) => {
            if (Array.isArray(d.unidades) && d.unidades.length > 0) {
              return d.unidades.map((id) => Number(id)).some((u) => selecionadas.includes(u));
            }
            if (d.id_unidade != null && d.id_unidade !== '') {
              return selecionadas.includes(Number(d.id_unidade));
            }
            if (d.id_linha != null && d.id_veiculo == null && d.id_funcionario == null) {
              return true;
            }
            return selecionadas.includes(-1);
          });
        }
        return filtrados;
      },
      async resolveLazySelectIds(refName, selectedIds, valueKey) {
        if (Array.isArray(selectedIds) && selectedIds.length > 0) {
          return { ids: selectedIds, implicit: false };
        }
        const selectRef = this.$refs[refName];
        if (!selectRef || typeof selectRef.fetchAllLazyItems !== 'function') {
          return { ids: [], implicit: true };
        }
        const { items } = await selectRef.fetchAllLazyItems({
          search: '',
          requestDataOverride: this.lazySelectRequestData,
        });
        const ids = this.filtraItensLazyParaIds(items || [])
          .map((item) => item[valueKey])
          .filter((id) => id != null && id !== '');
        return { ids, implicit: true };
      },
      limparResultadosRelatorio() {
        this.entradas = [];
        this.entradasFiltered = [];
        this.resolvedIdLinhas = null;
        this.resolvedIdVeiculos = null;
      },
      populaEntradas(idlinhas, idveiculos) {
        this.loading = true;
        let dataInicial = DateUtils.getDateSQLFormatted(this.dti);
        let dataFinal = DateUtils.getDateSQLFormatted(this.dtf);

        let body = {
            dti: dataInicial,
            dtf: dataFinal,
            idlinhas,
            idveiculos,
            idviagens: null
        }

        apiController.request(apiController.endpoints.getEntradaspordata, {
            data: body,
            silent: true,
            onSuccess: (response) => {
                this.entradas = response.data;
                this.entradasFiltered = this.aplicaFiltros(this.entradas);
                this.entradasFiltered.forEach(entrada => {
                  entrada.descricao_tipo_entrada = translateDbField(
                    entrada.translation_key_tipo_entrada,
                    entrada.descricao_tipo_entrada
                  );
                  return entrada;
                });
                this.loading = false;
            },
            onError: (e) => {
                this.loading = false;
                console.log(this.$t('system.messages.errorAxios'));
                console.log(e.message);
                if (e.message == "Request failed with status code 401") {
                this.mensagemAutorizacaoDialog =
                    this.$t('system.messages.accessDenied');
                this.autorizacaoDialog = true;
                }
            },
        });

        },
      async populaRelatorio() {
        this.$refs.form.validate();
        if (!this.formValidado) {
          return;
        }

        this.limparResultadosRelatorio();
        this.progressoDialog = true;
        this.mensagemProgressoDialog = this.$t('operation.search');

        let idlinhas;
        let idveiculos;
        try {
          const [linhasRes, veiculosRes] = await Promise.all([
            this.resolveLazySelectIds('linhasSelect', this.idLinhaSelected, 'id_linha'),
            this.resolveLazySelectIds('veiculosSelect', this.idVeiculoSelected, 'id_veiculo'),
          ]);
          idlinhas = linhasRes.ids;
          idveiculos = veiculosRes.ids;

          if (
            (linhasRes.implicit && idlinhas.length === 0) ||
            (veiculosRes.implicit && idveiculos.length === 0)
          ) {
            this.progressoDialog = false;
            this.$nextTick(() => { this.$refs.form.resetValidation(); });
            return;
          }

          if (linhasRes.implicit) {
            this.resolvedIdLinhas = idlinhas;
          }
          if (veiculosRes.implicit) {
            this.resolvedIdVeiculos = idveiculos;
          }
        } catch (_err) {
          this.progressoDialog = false;
          return;
        } finally {
          this.progressoDialog = false;
        }

        this.populaEntradas(idlinhas, idveiculos);
        this.$nextTick(() => { this.$refs.form.resetValidation(); });
      },
    },
  };
  </script>